import inventoryAPI from '@/services/api/inventory'
import { DateTime } from 'luxon'

const index = {
	namespaced: true,
	state: () => ({
		itemDetail: undefined,
	}),
	getters: {},
	mutations: {
		setItemDetail: (state, payload) => {
			state.itemDetail = payload
		},
	},
	actions: {
		loadItemDetail: async ({ commit }, payload) => {
			const { instituteId, itemId } = payload
			const response = await inventoryAPI.lookupItemDetail(
				instituteId,
				itemId
			)
			commit('setItemDetail', response.data)
		},
	},
}
export default index
